
export default {
  props: {
    trademarkList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isShow: false,
      defaultType: 0,
      initDataList: [],
      detailsList: []
    }
  },
  computed: {
  },
  mounted() {
    this.initData()
  },
  methods: {
     initData () {
            this.trademarkList.forEach((el, index) => {
              const tempObj = {
                items: el.items.slice(0, 6),
                isShowMore: el.items.length > 6,
                isUnfold: false
              }
              this.initDataList.push(tempObj)
            });
        },
    moreClick () {
         this.initDataList[this.defaultType].isUnfold = !this.initDataList[this.defaultType].isUnfold
            if (!this.initDataList[this.defaultType].isUnfold) {
              this.initDataList[this.defaultType].items = this.trademarkList[this.defaultType].items.slice(0, 6)
            } else {
              this.initDataList[this.defaultType].items = this.trademarkList[this.defaultType].items
            }
      },
     tabClick(i) {
        this.defaultType = i
        this.initData()
      },
  },
}
